<template>
    <div class="p-4 bg-white rounded-[19px] shadow flex-col justify-start items-start gap-3 inline-flex sm:p-6">
        <div class="text-slate-700 text-xl font-extrabold">Status</div>

        <div class="flex items-center gap-2">
            <div class="w-4 h-4 rounded-full shrink-0" :class="hasErrors ? 'bg-rose-400' : 'bg-emerald-400'"></div>
            <span class="text-base font-medium">{{ hasErrors ? 'Error' : 'Success' }}</span>
        </div>

        <div v-if="hasErrors" class="text-sm text-slate-500">
            {{ errorCount }} error{{ errorCount === 1 ? '' : 's' }} occurred during processing
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import type { IntegrationLogEntry } from '~/services/integrationLogsClient';

const props = defineProps<{
    entry: IntegrationLogEntry;
}>();

const hasErrors = computed(() => Array.isArray(props.entry.errors) && props.entry.errors.length > 0);
const errorCount = computed(() => (Array.isArray(props.entry.errors) ? props.entry.errors.length : 0));
</script>
